// Shared constants used across components

// U.S. states and area codes for phone number selection
export const STATE_AREA_CODES = [
  { state: "Select State", code: "" },
  { state: "Alabama", code: "+1205" },
  { state: "Alaska", code: "+1907" },
  { state: "Arizona", code: "+1480" },
  { state: "Arkansas", code: "+1501" },
  { state: "California", code: "+1213" },
  { state: "Colorado", code: "+1303" },
  { state: "Connecticut", code: "+1203" },
  { state: "Delaware", code: "+1302" },
  { state: "District of Columbia", code: "+1202" },
  { state: "Florida", code: "+1305" },
  { state: "Georgia", code: "+1404" },
  { state: "Hawaii", code: "+1808" },
  { state: "Idaho", code: "+1208" },
  { state: "Illinois", code: "+1312" },
  { state: "Indiana", code: "+1317" },
  { state: "Iowa", code: "+1319" },
  { state: "Kansas", code: "+1316" },
  { state: "Kentucky", code: "+1502" },
  { state: "Louisiana", code: "+1225" },
  { state: "Maine", code: "+1207" },
  { state: "Maryland", code: "+1301" },
  { state: "Massachusetts", code: "+1617" },
  { state: "Michigan", code: "+1313" },
  { state: "Minnesota", code: "+1612" },
  { state: "Mississippi", code: "+601" },
  { state: "Missouri", code: "+1314" },
  { state: "Montana", code: "+1406" },
  { state: "Nebraska", code: "+1308" },
  { state: "Nevada", code: "+1702" },
  { state: "New Hampshire", code: "+1603" },
  { state: "New Jersey", code: "+1201" },
  { state: "New Mexico", code: "+1505" },
  { state: "New York", code: "+1212" },
  { state: "North Carolina", code: "+1704" },
  { state: "North Dakota", code: "+1701" },
  { state: "Ohio", code: "+1216" },
  { state: "Oklahoma", code: "+1405" },
  { state: "Oregon", code: "+1503" },
  { state: "Pennsylvania", code: "+1215" },
  { state: "Rhode Island", code: "+1401" },
  { state: "South Carolina", code: "+1803" },
  { state: "South Dakota", code: "+1605" },
  { state: "Tennessee", code: "+1615" },
  { state: "Texas", code: "+1210" },
  { state: "Utah", code: "+1801" },
  { state: "Vermont", code: "+1802" },
  { state: "Virginia", code: "+1703" },
  { state: "Washington", code: "+1206" },
  { state: "West Virginia", code: "+1304" },
  { state: "Wisconsin", code: "+1414" },
  { state: "Wyoming", code: "+1307" },
];

// Display columns for data table
export const DISPLAY_COLUMNS = [
  "address", "addressCity", "addressState", "agentEmail", "agentLicenseNumber", "agentName", "agentPhoneNumber",
  "brokerName", "brokerPhoneNumber", "coAgentName", "coAgentNumber",
  "hdpData.homeInfo.homeStatus", "hdpData.homeInfo.homeType",
  "hdpData.homeInfo.price", "hdpData.homeInfo.priceChange",
  "hdpData.homeInfo.priceForHDP", "hdpData.homeInfo.rentZestimate",
  "hdpData.homeInfo.taxAssessedValue", "hdpData.homeInfo.zestimate",
  "listingAgents", "listingAttributionContact", "listingOffices",
  "perplexity_email", "pgapt", "price", "prop_stream_mail_found",
  "propstream_data.agent_email", "propstream_data.apn_info",
  "propstream_data.interest_rates", "propstream_data.legal_description",
  "propstream_data.loan_balances", "propstream_data.loan_payments",
  "propstream_data.loan_types", "propstream_data.owner_name",
  "scraped_agent_result", "zpid",
];

// Price and interest rate limits
export const PRICE_LIMITS = { min: 10000, max: 1000000, step: 10000 };
export const INTEREST_LIMITS = { min: 0, max: 0.1, step: 0.001 };

// Rows per page for pagination
export const ROWS_PER_PAGE = 12; 